import HeaderLink from './HeaderLink';

export { HeaderLink };
export default HeaderLink;
